import {
  Siren,
  Bug,
  Diamond,
  Lightbulb,
  Key,
  UsersThree,
  LinkSimple,
  MoneyWavy,
  MagnifyingGlass,
  ChatCircleDots,
  Trophy,
  ArrowsClockwise,
  Flag,
  WarningOctagon,
  Warning,
} from "@phosphor-icons/react";

// Canonical catalogue of icon types users can drop on the timeline.
// Order matches the order rendered in the icon picker and legend drawer.
export const EVENT_ICON_TYPES = [
  {
    type: "risk",
    label: "Risk",
    description: "A potential problem that could derail the plan",
    icon: Siren,
    color: "#dc2626",
  },
  {
    type: "issue",
    label: "Issue",
    description: "Something that has gone wrong and needs attention",
    icon: Bug,
    color: "#ea580c",
  },
  {
    type: "milestone",
    label: "Milestone",
    description: "A significant deliverable or checkpoint",
    icon: Diamond,
    color: "#2563eb",
  },
  {
    type: "opportunity",
    label: "Opportunity",
    description: "An idea or chance to accelerate / improve the outcome",
    icon: Lightbulb,
    color: "#eab308",
  },
  {
    type: "approval",
    label: "Approval / Gate",
    description: "A sign-off, go/no-go decision or governance gate",
    icon: Key,
    color: "#7c3aed",
  },
  {
    type: "meeting",
    label: "Meeting / Sync",
    description: "A scheduled alignment, workshop or review",
    icon: UsersThree,
    color: "#0891b2",
  },
  {
    type: "external",
    label: "External Dependency",
    description: "A hand-off or block that sits outside this team",
    icon: LinkSimple,
    color: "#475569",
  },
  {
    type: "cost",
    label: "Cost Alert",
    description: "Budget impact, spend event or commercial flag",
    icon: MoneyWavy,
    color: "#059669",
  },
  {
    type: "discovery",
    label: "Discovery",
    description: "New learning, research finding or investigation note",
    icon: MagnifyingGlass,
    color: "#db2777",
  },
  {
    type: "comment",
    label: "Comment",
    description: "A plain note or context on this date",
    icon: ChatCircleDots,
    color: "#64748b",
  },
];

// Lookup helpers (including legacy types so old events still render sanely)
const LEGACY_FALLBACKS = {
  achievement: { icon: Trophy, color: "#10b981", label: "Achievement" },
  decision: { icon: Lightbulb, color: "#f97316", label: "Decision" },
  change_request: { icon: ArrowsClockwise, color: "#a855f7", label: "Change Request" },
  custom: { icon: Flag, color: "#2563eb", label: "Custom" },
};

const BY_TYPE = (() => {
  const m = new Map();
  EVENT_ICON_TYPES.forEach((t) => m.set(t.type, t));
  return m;
})();

export function iconForEvent(event) {
  const t = event?.type;
  if (BY_TYPE.has(t)) return BY_TYPE.get(t);
  if (LEGACY_FALLBACKS[t]) {
    const l = LEGACY_FALLBACKS[t];
    return { type: t, label: l.label, icon: l.icon, color: l.color };
  }
  // safe default
  return {
    type: "comment",
    label: "Comment",
    icon: ChatCircleDots,
    color: "#64748b",
  };
}

// Simple alias (unused directly by callers right now but handy)
export const WarningIcon = Warning;
export const IssueIcon = WarningOctagon;
